/**
 * The multi edit config for the line widget
 * For reading/updating the line widget data when there are multiple widgets selected
 */
const multiEditConfig = {
  color: {
    key: 'strokeColor',
  },
};

export { multiEditConfig };
